import React from 'react'

const styles = {
    root: {
        display: 'grid',
        justifyItems: 'center',
        background: '#cccccc',
        height: "750px"
    },
    textdiv: {
        width: '300.4px',
        height: '60px',
        display: 'flex',
        background: 'rgba(0, 0, 0, 0.3)',
        borderRadius: '18px',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        alignContent: 'center',
        marginTop: '2rem'
    },
    icon: {
        width: '30px',
        marginRight: '10px'
    },
    overlayImage: {
        marginTop: '0rem',
        width: '80%'
    }
}

function SelfieTipOverlay(props) {
  return (
    <div className={`selfie-overlay ${props.subClass}`} >
        {/* <img style={styles.overlayImage} src={props.overlayImage} /> */}
        {props.overlayImage}
        <div className='arrows'>
            {props.directiveArrows}
        </div>
        <div style={styles.textdiv}>
            <img style={styles.icon} src={props.icon} />
            <text>{props.texts}</text>
        </div>
    </div>
  )
}

export default SelfieTipOverlay